<template>
  <div class="bg   mb-auto h-full overflow-auto bg-gradient-to-b  bg-gray-800 text-white" id="style-1">
    <div >
      <div class="bg-gray-900 bg-opacity-90 p-4  border-gray-700 shadow">
        <!-- Header / Stats -->
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div class="flex items-center gap-2">
            <i class="fas fa-box-open text-indigo-300 text-xl"></i>
            <h1 class="text-lg sm:text-xl font-semibold text-indigo-300">คลังปริศนา</h1>
          </div>
          <div class="grid grid-cols-2 sm:flex sm:flex-row gap-2 text-xs sm:text-sm">
            <div class="px-2 py-1 bg-gray-900 rounded border border-gray-700 flex items-center gap-2">
              <i class="fas fa-ticket-alt text-yellow-300"></i>
              <span>สุ่มฟรี:</span>
              <span class="font-semibold text-yellow-200">{{ freeClaims }}</span>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <div class="mt-3 border-t border-gray-700 pt-3">
          <div class="flex gap-2">
            <button
              class="px-3 py-2 rounded-md text-sm transition-colors duration-200"
              :class="activeTab==='vault' ? 'bg-indigo-600 text-white' : 'bg-gray-700 hover:bg-gray-600 text-gray-200'"
              @click="activeTab='vault'"
            >
              <i class="fas fa-warehouse mr-2"></i>ดูคลังปริศนา
            </button>
            <button
              class="px-3 py-2 rounded-md text-sm transition-colors duration-200"
              :class="activeTab==='roll' ? 'bg-indigo-600 text-white' : 'bg-gray-700 hover:bg-gray-600 text-gray-200'"
              @click="activeTab='roll'"
            >
              <i class="fas fa-gift mr-2"></i>สุ่มรางวัล
            </button>
          </div>

          <!-- Panel: Vault -->
          <div v-if="activeTab==='vault'" class="mt-4 grid gap-4">
            <div class="bg-gray-900 rounded-md p-3 border border-gray-800">
              <!-- Rule callout -->
              <div class="flex items-start gap-3 p-3 rounded-md border border-indigo-700/50 bg-gradient-to-r from-gray-800 to-gray-900">
                <i class="fas fa-info-circle text-indigo-300 text-lg"></i>
                <div class="text-xs sm:text-sm">
                  <div class="font-semibold text-indigo-300">กติกาการสุ่มจากคลัง</div>
                  <div class="text-gray-300 mt-0.5">
                    ระบบจะ<strong class="text-indigo-200">หยิบ 3 ชิ้นแรก</strong>มาสุ่ม
                    <span class="text-green-300 font-semibold">ได้รับ 1 ชิ้นเข้ากระเป๋า</span>
                    และ <span class="text-red-300 font-semibold">ลบอีก 2 ชิ้น</span>
                  </div>
                  <div v-if="topThreeDisplay.length" class="mt-2 flex items-center gap-2 text-xxs text-gray-400">
                    พรีวิว 3 ชิ้นแรก:
                    <div class="flex gap-2">
                      <div v-for="(it, i) in topThreeDisplay" :key="it.id" class="flex items-center gap-1">
                        <span class="w-4 h-4 rounded-full bg-gray-800 border border-gray-700 grid place-items-center text-xxs text-indigo-200">{{ i+1 }}</span>
                        <span class="truncate w-auto text-gray-300">{{ it.data?.name || it.id }} <span v-if="it.data?.level">+{{ it.data?.level}}</span></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mt-3">
                <h2 class="text-sm font-semibold text-indigo-300 flex items-center gap-2">
                  <i class="fas fa-warehouse"></i> ไอเทมในคลังปริศนา ({{ storageInventory.length }})
                </h2>
                <div class="flex items-center gap-2">
                  <span class="hidden sm:inline-flex items-center gap-1 text-xxs px-2 py-1 rounded-md border border-gray-700 bg-gray-800 text-gray-300">
                    <i class="fas fa-arrow-down-wide-short"></i> ใช้ลำดับจากซ้ายไปขวา — <span class="text-indigo-200">3 ชิ้นแรก</span> จะถูกสุ่ม
                  </span>
                  <button
                    class="py-2 px-4 rounded-md bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-semibold transition-all duration-200 flex items-center gap-2 disabled:bg-gray-600 disabled:text-gray-400"
                    :disabled="isClaiming || storageInventory.length<3 || !user"
                    @click="confirmVaultRoll=true"
                  >
                    <i class="fas fa-random"></i> สุ่มจาก 3 ชิ้นแรก → กระเป๋า
                  </button>
                </div>
              </div>

              <div v-if="loadingVault" class="py-8 text-center text-gray-300">
                <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-indigo-400 mx-auto mb-3"></div>
                กำลังโหลดคลัง...
              </div>
              <div v-else-if="vaultError" class="text-red-300 text-sm py-2 text-center">{{ vaultError }}</div>
              <div v-else-if="storageInventory.length===0" class="text-gray-400 text-sm py-2 text-center">ยังไม่มีไอเทมในคลัง</div>

              <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 mt-2">
                <div
                  v-for="(it, idx) in storageItems"
                  :key="it.id"
                  class="relative p-2 rounded-md bg-gray-800 border transition-all duration-200"
                  :class="[ 'hover:border-indigo-400', idx < 3 ? 'border-indigo-500 ring-1 ring-inset ring-indigo-500/40 highlight-3' : 'border-gray-700' ]"
                >
                  <div v-if="idx < 3" class="absolute -left-2 -top-2 z-10 bg-indigo-600 text-white text-xxs rounded-md px-1.5 py-0.5 shadow">อันดับ {{ idx+1 }}</div>
                  <div class="flex items-center gap-2">
                    <img
                      :src="it.data?.img || defaultItemImage"
                      class="w-12 h-12 object-cover rounded-md border-2"
                      :class="(it.data?.rarityColors?.borderColor)||'border-gray-600'"
                      @error="onImgError"
                    />
                    <div class="flex-1">
                      <div class="text-xxs font-semibold" :class="(it.data?.rarityColors?.textColor)||'text-gray-100'">
                        {{ it.data?.name || it.id }} <span v-if="it.data?.level">+{{ it.data?.level  }}</span>
                      </div>
                      <div class="text-xxs text-gray-300">{{ it.data?.type || '—' }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="text-xxs text-gray-400 mt-2">
                * การสุ่มจะหยิบ <span class="text-indigo-200 font-semibold">3 ชิ้นแรก</span> มาสุ่ม 1 ชิ้นเข้ากระเป๋า และลบอีก 2 ชิ้น
              </div>
            </div>
          </div>

          <!-- Panel: Roll (เปิดกล่องเข้าคลัง) -->
          <div v-else class="mt-4 grid md:grid-cols-2 gap-4">
            <!-- Rewards list -->
            <div class="bg-gray-900 rounded-md p-3 border border-gray-800">
              <div class="flex items-center justify-between mb-2">
                <h2 class="text-sm font-semibold text-indigo-300 flex items-center gap-2">
                  <i class="fas fa-list"></i> รางวัลที่เป็นไปได้
                </h2>
                <span class="text-xxs sm:text-xs text-gray-400">เรียงจากหายาก → ง่าย</span>
              </div>

              <div v-if="loadingRewards" class="py-8 text-center text-gray-300">
                <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-indigo-400 mx-auto mb-3"></div>
                กำลังดึงข้อมูล...
              </div>
              <div v-else-if="rewardError" class="text-red-300 text-sm py-2 text-center">{{ rewardError }}</div>
              <div v-else-if="nonCommonSortedRewards.length===0" class="text-gray-400 text-sm text-center py-2">ไม่มีข้อมูลรางวัล (นอกเหนือจาก Common)</div>

              <div class="space-y-2 max-h-96 overflow-y-auto pr-1">
                <div
                  v-for="(reward, idx) in nonCommonSortedRewards"
                  :key="idx"
                  class="p-2 rounded-md bg-gray-800 border border-gray-700 hover:border-indigo-400 transition-all duration-200"
                >
                  <div class="flex items-center gap-3">
                    <img
                      :src="getItemImage(reward.itemName)"
                      :alt="reward.itemName"
                      class="w-12 h-12 object-cover rounded-md border-2"
                      :class="getRarityBorderColor(reward.itemName)"
                      @error="onImgError"
                    />
                    <div class="flex-1">
                      <div class="flex items-center gap-2">
                        <span class="font-semibold text-sm" :class="getRarityTextColor(reward.itemName)">{{ getItemName(reward.itemName) }}</span>
                        <span v-if="showRarityPill(reward.itemName)" class="text-xxs px-2 py-0.5 rounded-full border" :class="rarityPillClass(reward.itemName)">{{ getRarityLabel(reward.itemName) }}</span>
                      </div>
                      <div class="text-xxs text-gray-300">โอกาส: {{ formatChance(reward.chance) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Actions -->
            <div class="bg-gray-900 rounded-md p-3 border border-gray-800 flex flex-col gap-3">
              <h2 class="text-sm font-semibold text-indigo-300 flex items-center gap-2">
                <i class="fas fa-dice"></i> สุ่มไอเทมเข้าคลังปริศนา
              </h2>

              <div class="flex flex-col sm:flex-row gap-2">
                <button
                  class="flex-1 py-3 px-4 rounded-md bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-semibold transition-all duration-200 flex items-center justify-center gap-2 disabled:bg-gray-600 disabled:text-gray-400"
                  :disabled="isOpening || isClaiming || freeClaims<=0 || !user"
                  @click="startOpenPreRoll('free')"
                >
                  <i class="fas fa-ticket-alt"></i>
                  <span v-if="preOpenActive && openingMode==='free'">กำลังเตรียมสุ่ม...</span>
                  <span v-else>สุ่มฟรี ({{ freeClaims }} ครั้ง)</span>
                </button>

                <button
                  class="flex-1 py-3 px-4 rounded-md bg-purple-600 hover:bg-purple-500 text-white text-sm font-semibold transition-all duration-200 flex items-center justify-center gap-2 disabled:bg-gray-600 disabled:text-gray-400"
                  :disabled="isOpening || isClaiming || (diamonds||0)<100 || !user"
                  @click="confirmDiamonds=true"
                >
                  <i class="fas fa-gem"></i>
                  <span v-if="preOpenActive && openingMode==='diamond'">กำลังเตรียมสุ่ม...</span>
                  <span v-else>สุ่มด้วยเพชร (100)</span>
                </button>
              </div>

              <div class="text-xxs text-gray-400">* ไอเทมที่ได้จะเข้า “คลังปริศนา” ก่อน แล้วค่อยสุ่มจากคลังเข้ากระเป๋าอีกที</div>

              <div v-if="claimMsg" class="text-center text-sm" :class="claimType==='success' ? 'text-green-300' : 'text-red-300'">
                {{ claimMsg }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pre-Open Modal (เปิดกล่อง ลุ้น 5 วิ) -->
    <div v-if="preOpenActive" class="fixed inset-0 bg-gray-900 bg-opacity-70 flex items-center justify-center p-4 z-50 transition-opacity duration-300 animate-modalFade">
      <div class="w-full max-w-sm bg-gray-800 text-gray-200 rounded-lg p-6 flex flex-col gap-4 shadow-lg border border-gray-700 animate-scaleIn">
        <div class="flex items-center justify-between">
          <h3 class="text-base font-semibold text-indigo-300 flex items-center gap-2">
            <i class="fas fa-box-open"></i> เตรียมสุ่มรางวัล...
          </h3>
          <span class="text-xxs text-gray-300">เหลือ {{ openTimeLeft.toFixed(1) }} วินาที</span>
        </div>
        <div class="flex flex-col items-center py-2">
          <img :src="mysteriousBoxImage" class="w-36 h-36 object-contain rounded-md border border-gray-700 jiggle" @error="onImgError">
          <div class="w-full h-2 bg-gray-700 rounded overflow-hidden mt-3">
            <div class="h-full bg-indigo-500 transition-all" :style="{ width: openProgress + '%' }"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pre-Roll Modal (คลัง 3 ชิ้นแรก ลุ้น 5 วิ) -->
    <div v-if="preRollActive" class="fixed inset-0 bg-gray-900 bg-opacity-70 flex items-center justify-center p-4 z-50 transition-opacity duration-300 animate-modalFade">
      <div class="w-full max-w-md bg-gray-800 text-gray-200 rounded-lg p-5 shadow-lg border border-gray-700 animate-scaleIn">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2">
            <i class="fas fa-dice text-indigo-300"></i>
            <h3 class="text-base font-semibold text-indigo-300">กำลังสุ่มจาก 3 ชิ้นแรก...</h3>
          </div>
        </div>

        <div class="grid grid-cols-3 gap-2 mt-3">
          <div
            v-for="(it, i) in preRollTopThree"
            :key="it.id"
            class="rounded-md p-2 border relative bg-gray-800/70"
            :class="i===spinIndex ? 'border-yellow-400 ring-2 ring-yellow-400/40 pulse' : 'border-gray-600 opacity-80'"
          >
            <div class="absolute -top-2 -left-2 bg-gray-900 text-indigo-200 text-xxs rounded px-1.5 py-0.5 border border-gray-700">#{{ i+1 }}</div>
            <img :src="it.data?.img || defaultItemImage" class="w-16 h-16 object-cover rounded-md border-2 mx-auto"
                 :class="(it.data?.rarityColors?.borderColor)||'border-gray-600'" @error="onImgError" />
            <div class="text-xxs text-center mt-1 truncate" :class="(it.data?.rarityColors?.textColor)||'text-gray-100'">
              {{ it.data?.name || it.id }}
            </div>
          </div>
        </div>

        <div class="w-full h-2 bg-gray-700 rounded overflow-hidden mt-4">
          <div class="h-full bg-indigo-500 transition-all" :style="{ width: preRollProgress + '%' }"></div>
        </div>
      </div>
    </div>

    <!-- Result Modal -->
    <div v-if="showResult" class="fixed inset-0 bg-gray-900 bg-opacity-70 flex items-center justify-center p-4 z-50 transition-opacity duration-300 animate-modalFade">
      <div class="w-full max-w-sm bg-gray-800 text-gray-200 rounded-lg p-6 flex flex-col gap-5 shadow-lg border border-gray-700 animate-scaleIn">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2">
            <i class="fas fa-gift text-indigo-300 text-xl"></i>
            <h3 class="text-base font-semibold text-indigo-300">{{ isVaultReveal ? 'ผลการสุ่มจาก 3 ชิ้นแรก' : 'คุณได้รับไอเทม' }}</h3>
          </div>
          <button @click="closeResult()" class="text-gray-400 hover:text-indigo-300 transition-colors duration-200" aria-label="ปิด">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- โชว์ 3 ใบพร้อมผล -->
        <div v-if="isVaultReveal && revealBundle.length" class="space-y-2">
          <div class="grid grid-cols-3 gap-2">
            <div
              v-for="(it, i) in revealBundle"
              :key="it.id"
              class="relative rounded-md p-2 border bg-gray-700/60"
              :class="it.id === lastClaimed?.id ? 'border-green-400 ring-2 ring-green-400/40' : 'border-gray-600 opacity-80'"
            >
              <div class="absolute -top-2 -left-2 bg-gray-900 text-indigo-200 text-xxs rounded px-1.5 py-0.5 border border-gray-700">#{{ i+1 }}</div>
              <img :src="it.data?.img || defaultItemImage" class="w-14 h-14 object-cover rounded-md border-2 mx-auto"
                   :class="(it.data?.rarityColors?.borderColor)||'border-gray-600'" @error="onImgError" />
              <div class="text-xxs text-center mt-1 truncate" :class="(it.data?.rarityColors?.textColor)||'text-gray-100'">
                {{ it.data?.name || it.id }}
              </div>
              <div v-if="it.id === lastClaimed?.id" class="mt-1 text-center text-xxs font-semibold text-green-300 flex items-center justify-center gap-1">
                <i class="fas fa-check-circle"></i> ได้รับ
              </div>
              <div v-else class="mt-1 text-center text-xxs text-red-300 flex items-center justify-center gap-1">
                <i class="fas fa-minus-circle"></i> ลบแล้ว
              </div>
            </div>
          </div>
        </div>

        <!-- โหมดผลลัพธ์ปกติ -->
        <div v-else>
          <div v-if="lastClaimed" class="bg-gray-700 p-3 rounded-md flex items-center gap-3">
            <img :src="lastClaimed.img || defaultItemImage" class="w-16 h-16 object-cover rounded-md border-2" :class="(lastClaimed.rarityColors?.borderColor)||'border-gray-600'" @error="onImgError" />
            <div class="flex-1">
              <div class="text-sm font-semibold" :class="(lastClaimed.rarityColors?.textColor)||'text-gray-100'">{{ lastClaimed.name || 'Unknown Item' }}</div>
              <div class="text-xxs text-gray-300">{{ lastClaimed.type || '—' }}</div>
            </div>
          </div>
          <div v-else class="text-red-300 text-sm text-center">ไม่สามารถแสดงผลลัพธ์</div>
        </div>

        <div class="flex justify-end">
          <button @click="closeResult()" class="bg-indigo-600 hover:bg-indigo-500 text-white py-2 px-5 rounded-md text-sm font-semibold transition-all duration-200">
            ปิด
          </button>
        </div>
      </div>
    </div>

    <!-- Confirm: Diamonds -->
    <div v-if="confirmDiamonds" class="fixed inset-0 bg-gray-900 bg-opacity-70 flex items-center justify-center p-4 z-50 animate-modalFade">
      <div class="w-full max-w-sm bg-gray-800 text-gray-200 rounded-lg p-5 border border-gray-700 animate-scaleIn">
        <div class="text-sm font-semibold mb-3 text-indigo-300 flex items-center gap-2">
          <i class="fas fa-gem"></i> ใช้เพชร 100 เพื่อสุ่มเข้าคลังปริศนา?
        </div>
        <div class="text-xs text-gray-300 mb-4">เพชรคงเหลือ: <span class="text-indigo-200 font-semibold">{{ diamondsDisplay }}</span></div>
        <div class="flex justify-end gap-2">
          <button class="py-2 px-4 rounded-md bg-gray-600 hover:bg-gray-500 text-sm" @click="confirmDiamonds=false">ยกเลิก</button>
          <button class="py-2 px-4 rounded-md bg-purple-600 hover:bg-purple-500 text-white text-sm font-semibold"
                  :disabled="isOpening || isClaiming || (diamonds||0)<100"
                  @click="confirmDiamonds=false; startOpenPreRoll('diamond')">
            ยืนยัน
          </button>
        </div>
      </div>
    </div>

    <!-- Confirm: Vault Roll -->
    <div v-if="confirmVaultRoll" class="fixed inset-0 bg-gray-900 bg-opacity-70 flex items-center justify-center p-4 z-50 animate-modalFade">
      <div class="w-full max-w-sm bg-gray-800 text-gray-200 rounded-lg p-5 border border-gray-700 animate-scaleIn">
        <div class="text-sm font-semibold mb-2 text-indigo-300 flex items-center gap-2">
          <i class="fas fa-random"></i> สุ่มจาก 3 รายการแรก เพื่อส่ง 1 รายการเข้ากระเป๋า?
        </div>
        <div class="text-xxs text-gray-400 mb-3">* 2 รายการที่ไม่ถูกเลือกจะถูกลบ</div>

        <div v-if="topThreeDisplay.length" class="grid grid-cols-3 gap-2 mb-4">
          <div v-for="(it,i) in topThreeDisplay" :key="it.id" class="rounded-md p-2 border border-gray-700 bg-gray-800/80">
            <div class="text-center text-xxs text-gray-400 mb-1">#{{ i+1 }}</div>
            <img :src="it.data?.img || defaultItemImage" class="w-14 h-14 mx-auto object-cover rounded-md border-2"
                 :class="it.data?.rarityColors?.borderColor || 'border-gray-600'" @error="onImgError">
            <div class="text-xxs mt-1 text-center truncate" :class="it.data?.rarityColors?.textColor || 'text-gray-100'">{{ it.data?.name || it.id }}</div>
          </div>
        </div>

        <div class="flex justify-end gap-2">
          <button class="py-2 px-4 rounded-md bg-gray-600 hover:bg-gray-500 text-sm" @click="confirmVaultRoll=false">ยกเลิก</button>
          <button class="py-2 px-4 rounded-md bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-semibold"
                  :disabled="isClaiming || storageInventory.length<3"
                  @click="confirmVaultRoll=false; startVaultPreRoll()">
            ยืนยัน
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { projectFirestore, projectFunctions } from '@/firebase/config';
import getUser from '@/composables/getUser';
import { usePlayerStore } from '@/composables/usePlayerStore';
import { useInventoryStore } from '@/composables/useInventoryStore';
import { isOldSchema, triggerReMigration } from '@/composables/useMigrationGuard';
import gameItemsData from '@/data/gameItems.json';

export default {
  name: 'MysteriousVault',
  setup() {
    const { user } = getUser();

    // tabs
    const activeTab = ref('vault');

    // ui state
    const isOpening = ref(false);
    const openingMode = ref(null);
    const isClaiming = ref(false);
    const showResult = ref(false);
    const lastClaimed = ref(null);
    const claimMsg = ref('');
    const claimType = ref('');
    const confirmDiamonds = ref(false);
    const confirmVaultRoll = ref(false);

    // Reveal / result for vault
    const preRollTopThree = ref([]);
    const isVaultReveal = ref(false);

    // --- NEW: 5s pre-animation states ---
    // For Vault Roll (3-first items)
    const preRollActive = ref(false);
    const preRollTimeLeft = ref(5.0);
    const spinIndex = ref(0);
    let spinTimer = null;
    let preRollTicker = null;
    const preRollDuration = 5_000;
    const preRollProgress = computed(() => Math.min(100, ((5 - preRollTimeLeft.value) / 5) * 100));

    // For Open Box (free/diamond)
    const preOpenActive = ref(false);
    const openTimeLeft = ref(5.0);
    let openTicker = null;
    const openProgress = computed(() => Math.min(100, ((5 - openTimeLeft.value) / 5) * 100));

    // Rewards & meta
    const rewards = ref([]);
    const itemMeta = ref({});
    const loadingRewards = ref(true);
    const rewardError = ref(null);

    // Player
    const diamonds = ref(0);
    const diamondsDisplay = computed(() => (diamonds.value ?? 0));
    const freeClaims = ref(0);
    const playerStore = usePlayerStore();
    const inventoryStore = useInventoryStore();

    // Vault
    const storageInventory = ref([]);
    const storageItems = ref([]);
    const loadingVault = ref(true);
    const vaultError = ref(null);

    // Bag
    const bagCount = ref(null);
    const bagCountDisplay = computed(() => bagCount.value ?? '—');

    // Assets
    const defaultItemImage = 'https://cdn-icons-png.flaticon.com/128/9342/9342159.png';
    const mysteriousBoxImage = 'https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/mysterious_box.png?alt=media&token=8637a242-9053-4d7f-a2b6-f40967c67371';

    // Helpers
    const rarityLabel = (name) => (itemMeta.value[name]?.rarityColors?.background || '').toLowerCase();
    const isCommon = (name) => rarityLabel(name) === 'common';
    const sortedRewards = computed(() => [...rewards.value].sort((a, b) => a.chance - b.chance));
    const nonCommonSortedRewards = computed(() => sortedRewards.value.filter(r => !isCommon(r.itemName)));
    const formatChance = (c) => isNaN(Number(c)) ? '—' : `${Number(c).toFixed(2)}%`;
    const getItemImage = (name) => itemMeta.value[name]?.img || defaultItemImage;
    const getItemName  = (name) => itemMeta.value[name]?.name || name;
    const getRarityLabel = (name) => {
      const lb = rarityLabel(name);
      return (lb && lb !== 'common') ? lb : '';
    };
    const getRarityTextColor = (name) => itemMeta.value[name]?.rarityColors?.textColor || 'text-gray-100';
    const getRarityBorderColor = (name) => itemMeta.value[name]?.rarityColors?.borderColor || 'border-gray-600';
    const showRarityPill = (name) => !!getRarityLabel(name);
    const rarityPillClass = (name) => {
      const lb = getRarityLabel(name).toLowerCase();
      const base = 'text-xxs border px-2 py-0.5 rounded-full';
      if (lb==='legendary') return `${base} border-yellow-400 text-yellow-300`;
      if (lb==='epic') return `${base} border-purple-400 text-purple-300`;
      if (lb==='rare') return `${base} border-blue-400 text-blue-300`;
      if (lb==='uncommon') return `${base} border-green-400 text-green-300`;
      return `${base} border-gray-500 text-gray-300`;
    };
    const onImgError = (e) => { e.target.src = defaultItemImage; };

    const topThreeDisplay = computed(() => storageItems.value.slice(0, 3));

    // Listeners
    const fetchRewards = () =>
      projectFirestore.collection('server').doc('mysteriousBox').onSnapshot(async (doc) => {
        try {
          loadingRewards.value = true; rewardError.value = null;
          if (doc.exists && Array.isArray(doc.data().rewards)) {
            rewards.value = doc.data().rewards || [];
            for (const r of rewards.value) {
              const itemName = r.itemName;
              if (itemName && !itemMeta.value[itemName]) {
                const data = gameItemsData[itemName];
                itemMeta.value[itemName] = data || { name: itemName };
              }
            }
          } else {
            rewards.value = [];
            rewardError.value = 'ไม่มีข้อมูลรางวัลในกล่องปริศนา';
          }
        } catch {
          rewardError.value = 'ไม่สามารถดึงข้อมูลรางวัลได้';
        } finally {
          loadingRewards.value = false;
        }
      }, () => { rewardError.value = 'เกิดข้อผิดพลาดในการเชื่อมต่อ'; loadingRewards.value = false; });

    watch(() => playerStore.characterData, (data) => {
      diamonds.value = data?.diamond || 0;
    }, { immediate: true });

    watch(() => playerStore.characterPrivateData, (data) => {
      freeClaims.value = data?.openFreeMysteriousBox || 0;
    }, { immediate: true });

    watch(() => inventoryStore.mysteriousStorageData, async (data) => {
      loadingVault.value = true;
      vaultError.value = null;
      try {
        if (data && isOldSchema(data, { requireWeightFields: false })) {
          console.warn('[MysteriousStorage] Old schema detected! Triggering re-migration...');
          await triggerReMigration();
          return;
        }
        const itemsObj = data ? (data.items || {}) : {};
        const mappedItems = Object.entries(itemsObj).map(([instanceId, itemData]) => {
          const template = gameItemsData[itemData.templateId] || {};
          const states = itemData.states || {};
          return {
            id: instanceId,
            data: {
              id: instanceId,
              instanceId,
              templateId: itemData.templateId,
              states,
              ...template,
              ...states,
              name: template.name || itemData.templateId,
              type: states.type || template.type || '',
              rarityColors: states.rarityColors || template.rarityColors,
            },
          };
        }).filter((it) => it.data.templateId);
        const hasOrder = mappedItems.some((it) => Number.isFinite(Number(it.data.states?.mysteriousOrder)));
        if (hasOrder) {
          mappedItems.sort((a, b) => {
            const orderA = Number.isFinite(Number(a.data.states?.mysteriousOrder)) ? Number(a.data.states.mysteriousOrder) : Number.MAX_SAFE_INTEGER;
            const orderB = Number.isFinite(Number(b.data.states?.mysteriousOrder)) ? Number(b.data.states.mysteriousOrder) : Number.MAX_SAFE_INTEGER;
            return orderA - orderB;
          });
        }
        storageInventory.value = mappedItems.map((it) => it.id);
        storageItems.value = mappedItems;
      } catch {
        vaultError.value = 'ไม่สามารถดึงข้อมูลคลังได้';
      } finally {
        loadingVault.value = false;
      }
    }, { immediate: true });

    watch(() => inventoryStore.bagData, (data) => {
      bagCount.value = data ? Object.keys(data.items || {}).length : 0;
    }, { immediate: true });

    // ---------- NEW: UX FLOW ----------
    // 1) เปิดกล่องเข้าคลัง: ลุ้น 5 วิ -> call fn -> result
    const startOpenPreRoll = (mode) => {
      if (!user.value) { claimMsg.value = 'กรุณาล็อกอินก่อน'; claimType.value = 'error'; return; }
      openingMode.value = mode;
      preOpenActive.value = true;
      openTimeLeft.value = 5.0;
      if (openTicker) clearInterval(openTicker);
      openTicker = setInterval(async () => {
        openTimeLeft.value = Math.max(0, openTimeLeft.value - 0.1);
        if (openTimeLeft.value <= 0) {
          clearInterval(openTicker);
          preOpenActive.value = false;
          await openBox(mode); // ส่งเข้าเซิร์ฟเวอร์จริง
        }
      }, 100);
    };

    const openBox = async (mode) => {
      try {
        isOpening.value = true;
        isClaiming.value = true;
        claimMsg.value = ''; claimType.value = '';
        const gameActions = projectFunctions.httpsCallable('gameActions');
        const res = await gameActions({
          action: mode === 'free' ? 'claimMysteriousItemFree' : 'claimMysteriousItemWithDiamonds',
        });
        if (res.data?.selectedItem) {
          lastClaimed.value = res.data.selectedItem;
          isVaultReveal.value = false;
          showResult.value = true;
          claimMsg.value = mode === 'free' ? 'สุ่มฟรีสำเร็จ' : 'สุ่มด้วยเพชรสำเร็จ';
          claimType.value = 'success';
        } else {
          throw new Error('ไม่ได้รับไอเทมจากการสุ่ม');
        }
      } catch (err) {
        claimMsg.value = err.message || 'เกิดข้อผิดพลาดในการสุ่ม';
        claimType.value = 'error';
      } finally {
        isOpening.value = false;
        isClaiming.value = false;
        openingMode.value = null;
      }
    };

    // 2) สุ่มจากคลัง (3 แรก): ลุ้น 5 วิ (วิ่งไฟบน 3 ใบ) -> call fn -> result 3 ใบ
    const startVaultPreRoll = () => {
      if (!user.value) { claimMsg.value = 'กรุณาล็อกอินก่อน'; claimType.value = 'error'; return; }
      if (storageInventory.value.length < 3) { claimMsg.value = 'ต้องมีไอเทมอย่างน้อย 3 ชิ้นในคลัง'; claimType.value = 'error'; return; }

      // snapshot 3 ชิ้นแรก
      preRollTopThree.value = storageItems.value.slice(0, 3);
      preRollActive.value = true;
      preRollTimeLeft.value = 5.0;
      isClaiming.value = true;

      // ไฟวิ่งวน
      if (spinTimer) clearInterval(spinTimer);
      spinTimer = setInterval(() => { spinIndex.value = (spinIndex.value + 1) % 3; }, 120);

      // นับถอยหลัง
      if (preRollTicker) clearInterval(preRollTicker);
      preRollTicker = setInterval(async () => {
        preRollTimeLeft.value = Math.max(0, preRollTimeLeft.value - 0.1);
        if (preRollTimeLeft.value <= 0) {
          clearInterval(preRollTicker);
          clearInterval(spinTimer);
          preRollActive.value = false;
          await rollFromVault(); // ส่งเข้าเซิร์ฟเวอร์จริง
        }
      }, 100);
    };

    const rollFromVault = async () => {
      try {
        const gameActions = projectFunctions.httpsCallable('gameActions');
        const res = await gameActions({ action: 'claimMysteriousItem' });
        if (res.data?.selectedItem) {
          lastClaimed.value = res.data.selectedItem;
          isVaultReveal.value = true;
          showResult.value = true;
          claimMsg.value = 'สุ่มจากคลังสำเร็จ';
          claimType.value = 'success';
        } else {
          claimMsg.value = 'สุ่มจากคลังสำเร็จ แต่ไม่พบข้อมูลไอเทม';
          claimType.value = 'error';
        }
      } catch (err) {
        claimMsg.value = err.message || 'เกิดข้อผิดพลาดในการสุ่มจากคลัง';
        claimType.value = 'error';
      } finally {
        isClaiming.value = false;
      }
    };

    const closeResult = () => {
      showResult.value = false;
      isVaultReveal.value = false;
      preRollTopThree.value = [];
    };

    // Lifecycle
    onMounted(() => {
      const unsubRewards = fetchRewards();

      onUnmounted(() => {
        if (unsubRewards) unsubRewards();
        // clear timers
        if (spinTimer) clearInterval(spinTimer);
        if (preRollTicker) clearInterval(preRollTicker);
        if (openTicker) clearInterval(openTicker);
      });
    });

    // hydrate meta
    watch(() => rewards.value, (list) => {
      for (const r of list) {
        const name = r.itemName;
        if (name && !itemMeta.value[name]) {
          const data = gameItemsData[name];
          itemMeta.value[name] = data || { name };
        }
      }
    }, { deep: true });

    const revealBundle = computed(() => preRollTopThree.value || []);

    return {
      user,
      activeTab,

      // ui base
      isOpening, openingMode, isClaiming,
      showResult, lastClaimed,
      claimMsg, claimType,
      confirmDiamonds, confirmVaultRoll,

      // pre-open (boxes)
      preOpenActive, openTimeLeft, openProgress, startOpenPreRoll,

      // pre-roll (vault)
      preRollActive, preRollTimeLeft, preRollProgress, spinIndex, startVaultPreRoll,

      // reveal
      preRollTopThree, isVaultReveal, revealBundle, closeResult,

      // rewards
      rewards, itemMeta, sortedRewards, nonCommonSortedRewards,
      loadingRewards, rewardError,

      // player
      diamonds, diamondsDisplay, freeClaims,

      // vault
      storageInventory, storageItems, loadingVault, vaultError, topThreeDisplay,

      // bag
      bagCountDisplay,

      // assets + helpers
      defaultItemImage, mysteriousBoxImage,
      formatChance, getItemImage, getItemName,
      getRarityLabel, getRarityTextColor, getRarityBorderColor,
      rarityPillClass, showRarityPill,
      onImgError,
    };
  },
};
</script>

<style scoped>
.max-h-96::-webkit-scrollbar,
.overflow-y-auto::-webkit-scrollbar { width: 6px; }
.max-h-96::-webkit-scrollbar-track,
.overflow-y-auto::-webkit-scrollbar-track { background: #374151; border-radius: 8px; }
.max-h-96::-webkit-scrollbar-thumb,
.overflow-y-auto::-webkit-scrollbar-thumb { background: #4b5563; border-radius: 8px; }
.max-h-96::-webkit-scrollbar-thumb:hover,
.overflow-y-auto::-webkit-scrollbar-thumb:hover { background: #6b7280; }

.animate-modalFade { animation: modalFade .2s ease-out; }
.animate-scaleIn  { animation: scaleIn .2s ease-out; }
@keyframes modalFade { from { opacity:0 } to { opacity:1 } }
@keyframes scaleIn  { from { transform:scale(.98) } to { transform:scale(1) } }

.jiggle { animation: jiggle 0.6s infinite; }
@keyframes jiggle {
  0%,100% { transform: rotate(0deg) }
  25% { transform: rotate(2deg) }
  50% { transform: rotate(-2deg) }
  75% { transform: rotate(1deg) }
}

.pulse { animation: pulseGlow 0.8s ease-in-out infinite; }
@keyframes pulseGlow {
  0% { box-shadow: 0 0 0 0 rgba(250,204,21,.45); }
  100% { box-shadow: 0 0 0 8px rgba(250,204,21,0); }
}

/* เน้น 3 ชิ้นแรกในกริด */
.highlight-3 { box-shadow: 0 0 0 1px rgba(99,102,241,.4) inset, 0 0 12px rgba(99,102,241,.15); }

/* Tailwind 2 helper */
.text-xxs { font-size: 0.675rem; line-height: 1rem; }
</style>
